<template>
  <ClientOnly>
    <div v-if="!isLargeScreen" class="flex h-full items-center">
      <div v-show="showBackButton">
        <MenuBackButton class="mr-1" />
      </div>
    </div>
  </ClientOnly>

  <div class="flex h-full">
    <div class="w-auto h-full content-center">
      <a
        v-if="!menuLogoBackHideLink"
        :href="routes().home()"
        :aria-label="t('menu.logo_back_menu.home')"
      >
        <img
          src="~/assets/img/logo-header.png"
          width="149"
          height="26"
          alt="EscapadaRural"
        />
      </a>

      <img
        v-else
        src="~/assets/img/logo-header.png"
        width="149"
        height="26"
        alt="EscapadaRural"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMenuReferrer } from '../composables/useMenuReferrer'

const { isLargeScreen } = useResponsive()
const { referrerValid } = useMenuReferrer()
const router = useRouter()
const route = useRoute()

const showBackButton = ref(false)

const menuLogoBackHideLink: boolean =
  route.meta.menuLogoBackHideLink === true ? true : false

onMounted(() => {
  if (import.meta.client) {
    showBackButton.value =
      ((referrerValid() && window.history.length > 1) ||
        !!router.options.history.state.back) &&
      route.path !== '/login-app'
  }
})
</script>
